import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  YAxis,
  XAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CouponsDashboardAPI } from "./../API/Coupons/CouponsDashboard";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

export const Graph_C = (props) => {
  const { GraphData, GraphData1, setGraphData1, setGraphData, setLoading } =
    props;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();

  const GetDateGraph = async (enddate) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");

    let objectDate = startDate;
    if (objectDate == "") {
      swal({
        title: "Please enter start date!",
        icon: "error",
        buttons: "Ok",
      });
      setLoading(false);
      setEndDate("");
    } else {
      let day = objectDate.getDate();
      let month = objectDate.getMonth();
      let year = objectDate.getFullYear();
      const fromDate = `${year}-${month + 1}-${day}`;
      // console.log(fromDate);
      let objectDateEnd = enddate;
      let dayEnd = objectDateEnd.getDate();
      let monthEnd = objectDateEnd.getMonth();
      let yearEnd = objectDateEnd.getFullYear();
      const toDate = `${yearEnd}-${monthEnd + 1}-${dayEnd}`;
      // console.log(toDate);
      const data = {
        mms_city_id: parseInt(cityId),
        start_date: fromDate,
        end_date: toDate,
      };
      const coupondetailData = await CouponsDashboardAPI(data, () => {
        navigate("/");
      });
      setLoading(false);
      if (coupondetailData.status === 429) {
        swal({
          title: `${coupondetailData.message}`,
          icon: "error",
          buttons: "Ok",
        });
        setLoading(true);
      } else if (coupondetailData.success == false) {
        swal({
          title: `${coupondetailData.message}`,
          icon: "error",
          buttons: "Ok",
        });
      } else {
        setGraphData(coupondetailData.data.downloaded_coupons_of_week);
        setGraphData1(coupondetailData.data.redeemed_coupons_of_week);
      }
    }
  };

  return (
    <Row className="mt-3">
      <div className="date_range">
        <div className="range_btn1">
          <p style={{ fontWeight: 700, fontSize: 16 }}>Choose Date Range</p>
          <div className="range_btn">
            <DatePicker
              className="dateRange_btn btn btn-primary"
              id="startDate"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="Start Date"
            />
            -
            <DatePicker
              className="dateRange_btn btn btn-primary"
              id="startDate"
              selected={endDate}
              onChange={(date) => {
                setEndDate(date);
                GetDateGraph(date);
              }}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="End Date"
            />
          </div>
        </div>
      </div>
      {/* 1 */}
      <Col>
        <span style={{ fontWeight: 700, fontSize: 16, marginLeft: 31 }}>
          Downloaded Coupons
        </span>
        <ResponsiveContainer width="85%" height={350}>
          <LineChart data={GraphData}>
            <CartesianGrid
              stroke="#c4c6c8"
              strokeDasharray="10.5"
              horizontal={true}
              vertical={false}
            />
            <XAxis dataKey="date" xAxisId={0} axisLine={false} dy={15} />
            <YAxis axisLine={false} dx={-17} />
            <Tooltip cursor={false} width={100} height={50} />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#A9CF4B"
              dot={false}
              strokeWidth={2}
              strokeLinecap="round"
            />
          </LineChart>
        </ResponsiveContainer>
      </Col>
      {/* 2 */}
      <Col>
        <span style={{ fontWeight: 700, fontSize: 16, marginLeft: 31 }}>
          Redeemed Coupons
        </span>
        <ResponsiveContainer width="85%" height={350}>
          <LineChart data={GraphData1}>
            <CartesianGrid
              stroke="#c4c6c8"
              strokeDasharray="10.5"
              horizontal={true}
              vertical={false}
            />
            <XAxis dataKey="date" xAxisId={0} axisLine={false} dy={15} />
            <YAxis axisLine={false} dx={-17} />
            <Tooltip cursor={false} width={100} height={50} />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#A9CF4B"
              dot={false}
              strokeWidth={2}
              strokeLinecap="round"
            />
          </LineChart>
        </ResponsiveContainer>
      </Col>
    </Row>
  );
};
